module.exports = __webpack_public_path__ + "media/images/flags/64/Austria-3d5e83040d0ffebe97d2a31ee30080e5.png";